import Vue from 'vue';
import Component from 'vue-class-component';
import BbModal from 'common/components/BbModal/BbModal.vue';

@Component({
  props: {
    step: {
      required: true,
      type: Number,
    },
  },
  components: {
    BbModal,
  },
})
export default class RemindersQuitModalComponent extends Vue {
  stepsLeftStrings = ['tres pasos', 'dos pasos', 'un paso'];

  get stepsLeft() {
    return this.stepsLeftStrings[this.step];
  }

  close() {
    this.$root.$emit('RegalendarioPopover',this.step);
    this.$emit('save')
  }
}
